module.exports = __webpack_public_path__ + "static/media/ic_学生.b8218b69.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_学生.svg
// module id = 193
// module chunks = 0